
export const NAME_REGEX = /^[A-Z '-]+$/i;
export const EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
export const PHONE_REGEX = /^\(\d{3}\) \d{3}-\d{4}$/;
